export default function rlxScrollTo() {
    $('[data-scroll-to]').on('click', function scrollHandler(e) {
        if ($(e.currentTarget).hasClass('disable-img-lazy-load')) { // scrolls without image lazy load
            const allImageElements = document.getElementsByTagName('img');
            const allImagesSrc = [];

            e.preventDefault();

            // removes lazy loading
            [...allImageElements].forEach((image) => {
                const dataSrc = image.getAttribute('data-src');
                image.setAttribute('src', dataSrc);
                image.classList.remove('lazyload');
            });

            const startScroll = () => {
                const id = $(this).attr('href');
                const headerHeight = $('.header').outerHeight();

                if (id) {
                    const scrollPosition = $(id).offset().top - headerHeight;
                    $('html, body').animate({ scrollTop: scrollPosition }, 'slow');
                    // set focus on contact form textarea on rlx model pages
                    if (id === '#model-contact') {
                        const contactForm = document.querySelector('.js-rlx-v7-contact__message-container');
                        const textarea = contactForm.querySelector('textarea');
                        textarea.focus();
                    }
                }
            };

            const checkImage = path => new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve({ path, status: 'ok' });
                img.onerror = () => resolve({ path, status: 'error' });
                img.src = path;
            });

            // gets all img sources
            [...allImageElements].forEach((image) => {
                if (image.src) {
                    allImagesSrc.push(image.src);
                }
            });

            // eslint-disable-next-line max-len
            const loadImagesAndScroll = imagesSources => Promise.all(imagesSources.map(checkImage)).then(() => {
                startScroll();
            });

            // scrolls when all images are loaded (when all promises for each image are resolved)
            loadImagesAndScroll(allImagesSrc);
        } else { // scrolls with image lazy load (example: scroll-to-top button)
            let scrollPosition = 0;
            const id = $(this).attr('href');
            const headerHeight = $('.header').outerHeight();
            e.preventDefault();

            if (id) {
                scrollPosition = $(id).offset().top - headerHeight;
            }

            $('html, body').animate({ scrollTop: scrollPosition }, 'slow');
        }
    });
}
